import { jsx as A, jsxs as R } from "react/jsx-runtime";
import { forwardRef as x, useRef as v, useImperativeHandle as E, useEffect as N } from "react";
import H from "../builders-icons/dist/systems/sort.js";
import { Chevron as O } from "../chevron/chevron.js";
import { useTracking as k, animateHidden as B, getText as I, onRoleButtonKeyDown as j } from "../utils.js";
import g from "clsx";
import c from "./table.module.css.js";
const h = (u, f = "rowgroup") => {
  const d = u[0].toUpperCase() + u.slice(1), o = ({ className: n, ...s }, a) => /* @__PURE__ */ A(
    u,
    {
      ...s,
      "aria-colspan": "colSpan" in s ? s.colSpan : void 0,
      "aria-rowspan": "rowSpan" in s ? s.rowSpan : void 0,
      className: g(c[u], n),
      ref: a,
      role: f
    }
  );
  return Object.defineProperty(o, "name", { value: d }), x(o);
}, K = h("thead"), P = h("tbody"), q = h("tfoot"), L = h("tr", "row"), M = h("th", "columnheader"), $ = h("td", "cell"), z = x(function({
  className: f,
  fixed: d = !1,
  mobileDivide: o = 0,
  variant: n = "regular",
  ...s
}, a) {
  const i = v(null), m = o === "space-between", r = g(f, c.table, c[n], {
    [c.fixed]: d,
    [c.isMobileDivide]: m || Number(o),
    [c.isSpaceBetween]: m
  });
  return E(a, () => i.current), N(() => {
    var S, t;
    const e = i.current, p = ((t = (S = e == null ? void 0 : e.tHead) == null ? void 0 : S.rows) == null ? void 0 : t[0].cells) || [], T = e == null ? void 0 : e.querySelectorAll("tbody > tr");
    e == null || e.style.setProperty("--builders-sm-divide", `${o || 0}`), e != null && e.querySelector("tfoot > tr > th:not(:first-child)") && console.warn(
      "Tfoot should only contain one th element as first child:",
      i.current
    ), Array.from(p || [], (l) => l.scope = "col"), Array.from(
      T || [],
      (l) => Array.from(l.cells, (b, C) => {
        var y;
        b.nodeName === "TH" && (b.role = "rownheader", b.scope = "row"), b.setAttribute("data-th", ((y = p[C]) == null ? void 0 : y.textContent) || "");
      })
    );
  }, [s.children, o]), /* @__PURE__ */ A("table", { ...s, role: "table", ref: i, className: r });
});
let w;
const D = x(
  function({
    className: f,
    children: d,
    icon: o = !0,
    expanded: n = !1,
    tracking: s = !0,
    variant: a = "yellow",
    ...i
  }, m) {
    const r = v(null), e = v(n), p = o === !0 ? "left" : o || "", T = /* @__PURE__ */ A(O, { open: n, className: c.icon }), S = k(s);
    return E(m, () => r.current), N(() => {
      var y;
      const t = (y = r.current) == null ? void 0 : y.closest("tr"), l = t == null ? void 0 : t.nextElementSibling, b = l == null ? void 0 : l.firstElementChild, C = (t == null ? void 0 : t.getAttribute("data-expanded")) === "true";
      t == null || t.setAttribute("data-expanded", `${n}`), n !== C && b instanceof HTMLTableCellElement && (t == null || t.setAttribute("data-expanded", "true"), B(b, !n, l).then(
        () => n || (t == null ? void 0 : t.removeAttribute("data-expanded"))
      ));
    }, [n, p]), e.current !== n && (e.current = n, clearTimeout(w), w = setTimeout(S, 100, {
      eventCategory: "table_expander",
      eventAction: n ? "open" : "close",
      eventLabel: I(r.current)
    })), /* @__PURE__ */ R(
      "div",
      {
        ...i,
        "aria-expanded": !!n,
        className: g(
          c.expander,
          c[p],
          c[a],
          f
        ),
        onKeyDown: j,
        ref: r,
        role: "button",
        tabIndex: 0,
        children: [
          p === "left" && T,
          d,
          p === "right" && T
        ]
      }
    );
  }
), U = {
  asc: "ascending",
  desc: "descending",
  false: "none"
}, _ = x(
  function({ children: f, className: d, sort: o = !1, ...n }, s) {
    var m;
    const a = v(null), i = (m = Object.entries(U).find(([r, e]) => o === r || o === e)) == null ? void 0 : m.pop();
    return E(s, () => a.current), N(() => {
      var e;
      const r = (e = a.current) == null ? void 0 : e.closest("th");
      return r == null || r.setAttribute("aria-sort", i || "none"), () => r == null ? void 0 : r.removeAttribute("aria-sort");
    }, [i]), /* @__PURE__ */ R(
      "div",
      {
        ...n,
        className: g(c.sorter, d),
        onKeyDown: j,
        tabIndex: 0,
        role: "button",
        ref: a,
        children: [
          /* @__PURE__ */ A(H, { className: c.icon }),
          f
        ]
      }
    );
  }
), Y = Object.assign(z, {
  Thead: K,
  Tbody: P,
  Tfoot: q,
  Tr: L,
  Th: M,
  Td: $,
  Expander: D,
  Sorter: _
});
export {
  D as Expander,
  _ as Sorter,
  Y as Table,
  P as Tbody,
  $ as Td,
  q as Tfoot,
  M as Th,
  K as Thead,
  L as Tr
};
//# sourceMappingURL=table.js.map
